export default "__VITE_ASSET__7yXo8WoI__"